import { render, staticRenderFns } from "./Zxbx.vue?vue&type=template&id=8fed669c&"
import script from "./Zxbx.vue?vue&type=script&lang=js&"
export * from "./Zxbx.vue?vue&type=script&lang=js&"
import style0 from "./Zxbx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports